const CaretLeft = () => (
  <svg
    className="app"
    width="8"
    height="16"
    viewBox="0 0 8 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.38049 0.6746C7.57934 0.807065 7.7108 1.00427 7.74595 1.22282C7.7811 1.44138 7.71706 1.66339 7.56793 1.84L2.31959 8L7.56793 14.16C7.71706 14.3366 7.7811 14.5586 7.74595 14.7772C7.7108 14.9957 7.57933 15.1929 7.38049 15.3254C7.28147 15.3936 7.16806 15.4435 7.04696 15.4721C6.92587 15.5007 6.79955 15.5074 6.67547 15.4919C6.5514 15.4763 6.43209 15.4389 6.3246 15.3817C6.2171 15.3245 6.12361 15.2488 6.04966 15.1589L0.501412 8.6493C0.341783 8.46253 0.25537 8.23449 0.25537 8C0.25537 7.76551 0.341783 7.53747 0.501412 7.3507L6.04966 0.841087C6.12362 0.75125 6.2171 0.675497 6.3246 0.618309C6.43209 0.56112 6.5514 0.523658 6.67547 0.508136C6.79955 0.492614 6.92587 0.499348 7.04696 0.527941C7.16806 0.556533 7.28147 0.606403 7.38049 0.6746Z"
    />
  </svg>
);

export default CaretLeft;
